module.exports = __webpack_public_path__ + "static/media/5543.a620bb42.jpg";